import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./features/login/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./features/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'documents',
    loadChildren: () =>
        import('./features/documents/documents.module').then(m => m.DocumentsModule)
  },
  {
    path: 'enquetes',
    loadChildren: () =>
        import('./features/enquetes/enquetes.module').then(m => m.EnquetesModule)
  },
  {
    path: 'enveloppe',
    loadChildren: () =>
        import('./features/enveloppe/enveloppe.module').then(m => m.EnveloppeModule)
  },{
    path: 'factures',
    loadChildren: () =>
        import('./features/facture/facture.module').then(m => m.FactureModule)
  },
  {
    path: 'conditions',
    loadChildren: () =>
        import('./features/conditions/conditions.module').then(m => m.ConditionsModule)
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    onSameUrlNavigation: 'reload'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
